
(function(){

    //
    // Set the token automatically in the jquery calls
    //
    $.beforeReady(function(){ // On before ready

        $(document).ajaxSend(function(elm, xhr, s){
            if (s.type === "POST") {
                xhr.setRequestHeader('x-csrf-token', ws.csrf_token);
            }
        });

    });


})(); // End auto-executable anonymous function


